import { useQuery } from "@tanstack/react-query"
import { api, type ApiEnvelope, type Settings } from "@/lib/api"

export function useSettings() {
  return useQuery<Settings>({
    queryKey: ["settings"],
    queryFn: async () => {
      const res = await api.get<ApiEnvelope<Settings>>("/settings")
      return res.data.data
    },
    staleTime: 5 * 60 * 1000,
  })
}
